import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { KeyRound, X } from "lucide-react";
import { toast } from "sonner";
import { OpenResidentButton } from "@/components/nds/OpenResidentButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/re`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("nex_token")}` } });

/** PACT Life Pass board: residents who tapped "Forgot PIN". Setting a new PIN on their page closes the request. */
export default function PinResetRequests() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => axios.get(`${API}/pin-reset-requests`, auth()).then((r) => setRows(r.data.requests)).catch(() => setRows(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!rows) return null;
  const dismiss = async (id) => {
    try { await axios.post(`${API}/pin-reset-requests/${id}/dismiss`, null, auth()); toast.success("Request dismissed"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not dismiss"); }
  };
  return (
    <section data-testid="lp-pin-resets" className="space-y-2">
      <h3 className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Forgot PIN requests · {rows.length}</h3>
      {rows.length ? (
        <ul className="divide-y divide-white/5 border border-amber-400/30 rounded-sm">
          {rows.map((x) => (
            <li key={x.id} data-testid={`lp-pin-reset-${x.id}`} className="flex items-center gap-3 px-4 py-2 text-sm">
              <KeyRound className="h-4 w-4 text-amber-300 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-white truncate flex items-center gap-2">{x.resident_name}<OpenResidentButton residentId={x.resident_id} name={x.resident_name} testid={`open-resident-pin-${x.id}`} /></div>
                <div className="text-[11px] text-nex-muted">phone ending {x.phone_last4} · {new Date(x.created_at).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}{x.texted ? " · case manager texted" : ""}</div>
              </div>
              <span className="text-[11px] text-nex-muted hidden sm:inline">Set a new PIN on their Pillar page</span>
              <button type="button" onClick={() => dismiss(x.id)} data-testid={`lp-pin-reset-dismiss-${x.id}`} aria-label="Dismiss" className="p-1 text-nex-muted hover:text-white"><X className="h-4 w-4" /></button>
            </li>
          ))}
        </ul>
      ) : <p data-testid="lp-pin-resets-empty" className="text-sm text-nex-muted">No one is waiting on a new PIN.</p>}
    </section>
  );
}
